/* global __BUILD_NUMBER__, __BRANCH__, __DATE__, __DATE_TIME__, __COMMIT__, __VERSION__ */

export const BUILD_INFO = {
    BUILD_NUMBER: __BUILD_NUMBER__,
    BRANCH: __BRANCH__,
    DATE: __DATE__,
    DATE_TIME: __DATE_TIME__,
    COMMIT: __COMMIT__,
    VERSION: __VERSION__,
};
